import MuiSkeleton, {
  SkeletonProps as MuiSkeletonProps,
} from "@mui/material/Skeleton";

const Skeleton: React.FC<MuiSkeletonProps> = (props) => {
  return <MuiSkeleton {...props} />;
};

export default Skeleton;
